import { nanoid } from 'nanoid/non-secure';

import { USER_ID_KEY } from './constants';

export const handleAnonId = () => {
    let storageUserId = window.localStorage.getItem(USER_ID_KEY);

    if (!storageUserId) {
        storageUserId = nanoid();
        window.localStorage.setItem(USER_ID_KEY, storageUserId);
    }

    if (typeof window !== `undefined`) {
        if (window.analytics && window.analytics.user) {
            window.analytics.user().anonymousId(storageUserId);
        }
    }
    return storageUserId;
};

export const getUserId = () => {
    const userId = window.localStorage.getItem(USER_ID_KEY);

    if (!userId) {
        return handleAnonId();
    }
    return userId;
};
